module.exports = __webpack_public_path__ + "static/pv-restaurant-interior-35ac4f8992a2f70c4f596aca04dd40d0.jpg";